export default "<div {{#if (not (empty id))}}id=\"{{id}}\"{{/if}} class=\"{{class}} mainMenu\" data-binding=\"hoverable\">\n    {{> @partial-block }}\n</div>";